/*
 * BethelReport Messages
 *
 * This contains all the text for the BethelReport component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  month: {
    id: 'app.containers.BethelReport.month',
    defaultMessage: 'Month',
  },
  year: {
    id: 'app.containers.BethelReport.year',
    defaultMessage: 'Year',
  },
  copyReport: {
    id: 'app.containers.BethelReport.copyReport',
    defaultMessage: 'Copy report',
  },
  booksAndBiblePlacements: {
    id: 'app.containers.BethelReport.biblePlacements',
    defaultMessage: 'Books and bible placements',
  },
  magazinBrochureTractPlacements: {
    id: 'app.containers.BethelReport.magazinePlacements',
    defaultMessage: 'Magazine, brochure, and tract placements',
  },
  videoShowings: {
    id: 'app.containers.BethelReport.videoShowings',
    defaultMessage: 'Video showings',
  },
  receivedAddresses: {
    id: 'app.containers.BethelReport.receivedAddresses',
    defaultMessage: 'Received addresses, phone or e-mail contacts',
  },
  heldConversations: {
    id: 'app.containers.BethelReport.heldConversations',
    defaultMessage: 'Held conversations',
  },
  missingReports: {
    id: 'app.containers.BethelReport.missingReports',
    defaultMessage: 'Missing reports',
  },
  establishedBibleStudies: {
    id: 'app.containers.BethelReport.establishedBibleStudies',
    defaultMessage: 'Established bible studies',
  },
  publisherHours: {
    id: 'app.containers.BethelReport.publisherHours',
    defaultMessage: 'Total service hours',
  },
  participatingPioneers: {
    id: 'app.containers.BethelReport.participatingPioneers',
    defaultMessage: 'Participating pioneers',
  },
  participatingPublishers: {
    id: 'app.containers.BethelReport.participatingPublishers',
    defaultMessage: 'Participating publishers',
  },
  reportsFromPreviousMonths: {
    id: 'app.containers.BethelReport.reportsFromPreviousMonths',
    defaultMessage: 'Reports form previous months',
  },

  copySuccessful: {
    id: 'app.containers.BethelReport.copySuccessful',
    defaultMessage: 'Report successfully copied to clipboard',
  },
  noReportsAvailable: {
    id: 'app.containers.BethelReport.noReportsAvailable',
    defaultMessage: 'No branch reports available yet',
  },
});
